import React from 'react';
import { cloneDeep } from 'lodash';
import Fetch from '@/workflows/hooks/fetch';
import TabPanes from '@/components/tabs/TabPanes';
import TaskSummaryList from './TaskSummaryList';
import TaskFieldList from '../forms/components/TaskFieldList';
import RequestFieldList from '../../forms/components/RequestFieldList';
import RequestDestinationList from '../../components/RequestDestinationList';
import { requestTaskTabs } from '../constants';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const tabs = {
  [requestTaskTabs.TASK.name]: { Content: TaskFieldList, section: 'task', hasPane: true },
  [requestTaskTabs.SUMMARY.name]: { Content: TaskSummaryList, hasPane: true },
  [requestTaskTabs.DESTINATION.name]: { Content: RequestDestinationList, hasPane: true },
  [requestTaskTabs.PROJECT.name]: { Content: RequestFieldList, section: 'project', hasPane: true },
  [requestTaskTabs.ABOUT.name]: { Content: RequestFieldList, section: 'about', hasPane: true },
  [requestTaskTabs.COMMENTS.name]: { Content: TaskFieldList, section: 'comments', hasPane: true },
};

const TaskTabPanes = () => {
  const state = Selectors.useTaskTabPanes();
  const updateTab = Events.useUpdateActiveTaskTab();
  Fetch.useFetchWorkflow({ category: 'open', code: state.workflowKey }, state.readStatus);
  const tabInfo = cloneDeep(requestTaskTabs);
  tabInfo.TASK.error = state.saveErrors.find((e) => e.context.entity.includes('task'));
  tabInfo.COMMENTS.error = state.saveErrors.find((e) => e.context.entity.includes('comments'));

  const onRender = (name) => {
    const { hasPane, Content, section } = tabs[name];
    return {
      hasPane,
      content: (<Content category="tasks" code={state.request.code} request={state.request} section={section} />),
    };
  };

  return (
    <TabPanes
      activeIndex={state.activeStepIndex}
      attached
      className="aridhia-task-panel-tabs"
      entity="task"
      indexes={state.indexes}
      tabs={tabInfo}
      onRender={onRender}
      onTabChange={(e, { activeIndex }) => updateTab({ step: activeIndex })}
      sections={state.sections}
    />
  );
};

export default TaskTabPanes;
